"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupportSettingsRepository = void 0;
const httpRepository_1 = __importDefault(require("./httpRepository"));
exports.SupportSettingsRepository = {
    getGoBranch: async ({ companyId }) => {
        const response = await httpRepository_1.default.tradeshiftGo().get(`/rest/company/${companyId}/go-branch`);
        return response.data;
    },
    storeGoBranch: async ({ companyId, goBranchId }) => {
        const response = await httpRepository_1.default.tradeshiftGo().put(`/rest/company/${companyId}/go-branch`, { goBranchId });
        return response.data;
    },
    clearGoBranch: async ({ companyId }) => {
        const response = await httpRepository_1.default.tradeshiftGo().delete(`/rest/company/${companyId}/go-branch`);
        return response.data;
    },
};
